import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

const baseClass =
  "inline-flex items-center justify-center gap-2 rounded-full px-7 py-3 text-sm sm:text-base font-semibold shadow-md transition-all duration-300 ease-out hover:shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-orange)] focus-visible:ring-offset-2";

/**
 * Both variants are built from the single brand orange:
 * solid fill, or outline that fills on hover. No other accent colour.
 */
const variantClass = {
  solid:
    "bg-[var(--brand-orange)] text-white hover:bg-[var(--brand-orange-dark)] focus-visible:ring-offset-white",
  outline:
    "border-2 border-[var(--brand-orange)] bg-white text-[var(--brand-orange)] hover:bg-[var(--brand-orange)] hover:text-white focus-visible:ring-offset-white",
};

const CtaLink = ({ to, label, variant = "solid", className = "" }) => (
  <Link to={to} className={`${baseClass} ${variantClass[variant]} ${className}`}>
    <span>{label}</span>
    <FaArrowRight aria-hidden="true" className="text-xs sm:text-sm" />
  </Link>
);

export default CtaLink;
